<template>
  <button-base medium="facebook" :title="i18n.t('public.social.share_on_facebook')" class="facebook"
               @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import FacebookMixin from '@/share/campaign/facebook-mixin'

export default {
  components: { ButtonBase },

  mixins: [FacebookMixin]
}
</script>

<style lang="scss" scoped>
  $facebook-blue: #1977f2;
  .btn.facebook {
    background-color: $facebook-blue;
    color: white;
    border-color: $facebook-blue;
  }
</style>
